import React from "react"

import { Button } from "./style"

const CtaButton = ({ text, small = false }) => (
  <Button small={small}>{text}</Button>
)

export default CtaButton
